import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const ASSETS = {
  IRONBEARS_GOLDENEAGLES: {
    background: "/duel-bg/ironbears-goldeneagles.png",
    ironBearsPlayerBox: "/teams/ironbears-player-box.svg",
    goldeneaglesPlayerBox: "/teams/goldeneagles-player-box.svg",
  },
  IRONBEARS_BULLMASTERS: {
    background: "/duel-bg/ironbears-bullmasters.png",
    ironBearsPlayerBox: "/teams/ironbears-player-box.svg",
    bullmastersPlayerBox: "/teams/bullbears-player-box.svg",
  },
  IRONBEARS_ALPHAWOLVES: {
    background: "/duel-bg/alphawolves-ironbears.png",
    ironBearsPlayerBox: "/teams/ironbears-player-box.svg",
    alphawolvesPlayerBox: "/teams/alphawolves-player-box.svg",
  },
  GOLDEN_EAGLES_ALPHAWOLVES: {
    background: "/duel-bg/alphawolves-goldeneagles.png",
    goldeneaglesPlayerBox: "/teams/goldeneagles-player-box.svg",
    alphawolvesPlayerBox: "/teams/alphawolves-player-box.svg",
  },
  GOLDEN_EAGLES_BULLMASTERS: {
    background: "/duel-bg/goldeneagles-bullmasters.png",
    goldeneaglesPlayerBox: "/teams/goldeneagles-player-box.svg",
    bullmastersPlayerBox: "/teams/bullbears-player-box.svg",
  },
  BULLMASTERS_ALPHAWOLVES: {
    background: "/duel-bg/bullmasters-alphawolves.png",
    bullmastersPlayerBox: "/teams/bullbears-player-box.svg",
    alphawolvesPlayerBox: "/teams/alphawolves-player-box.svg",
  },
};

// --- Motion variants (do NOT touch your styles; only movement/opacity)
const bgVariants = {
  hidden: { opacity: 0, scale: 1.02 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, scale: 1.01, transition: { duration: 0.35 } },
};

const sideVariants = (side) => ({
  hidden: { x: side === "left" ? "-20vw" : "20vw", opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 140, damping: 16, mass: 0.7 },
  },
  exit: {
    x: side === "left" ? "-10vw" : "10vw",
    opacity: 0,
    transition: { duration: 0.25 },
  },
});

export default function DuelComponent({ identifier }) {
  const renderOponents = (identifier) => {
    switch (identifier) {
      case "IRONBEARS_GOLDENEAGLES":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.IRONBEARS_GOLDENEAGLES.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.IRONBEARS_GOLDENEAGLES.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_GOLDENEAGLES.ironBearsPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_GOLDENEAGLES.goldeneaglesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      case "IRONBEARS_BULLMASTERS":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.IRONBEARS_BULLMASTERS.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.IRONBEARS_BULLMASTERS.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_BULLMASTERS.ironBearsPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_BULLMASTERS.bullmastersPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      case "IRONBEARS_ALPHAWOLVES":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.IRONBEARS_ALPHAWOLVES.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.IRONBEARS_ALPHAWOLVES.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_ALPHAWOLVES.ironBearsPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.IRONBEARS_ALPHAWOLVES.alphawolvesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      case "GOLDEN_EAGLES_ALPHAWOLVES":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.GOLDEN_EAGLES_ALPHAWOLVES.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.GOLDEN_EAGLES_ALPHAWOLVES.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.GOLDEN_EAGLES_ALPHAWOLVES.alphawolvesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.GOLDEN_EAGLES_ALPHAWOLVES.goldeneaglesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      case "GOLDEN_EAGLES_BULLMASTERS":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.GOLDEN_EAGLES_BULLMASTERS.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.GOLDEN_EAGLES_BULLMASTERS.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.GOLDEN_EAGLES_BULLMASTERS.goldeneaglesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.GOLDEN_EAGLES_BULLMASTERS.bullmastersPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      case "BULLMASTERS_ALPHAWOLVES":
        return (
          <div>
            <AnimatePresence mode="wait">
              <motion.img
                key={ASSETS.BULLMASTERS_ALPHAWOLVES.background}
                className=" absolute left-0 top-0  w-full h-full  "
                src={ASSETS.BULLMASTERS_ALPHAWOLVES.background}
                alt=""
                variants={bgVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              />
            </AnimatePresence>

            <motion.div
              key={`left-${identifier}`}
              className="absolute right-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("left")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.BULLMASTERS_ALPHAWOLVES.bullmastersPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>

            <motion.div
              key={`right-${identifier}`}
              className="absolute left-[65%] top-[45%] translate-x-[-50%] translate-y-[-50%] z-[3]"
              variants={sideVariants("right")}
              initial="hidden"
              animate="show"
              exit="exit"
            >
              <img
                className="w-[330px]"
                src={ASSETS.BULLMASTERS_ALPHAWOLVES.alphawolvesPlayerBox}
                alt=""
              />
              <img
                src="/avatar/avatar-default.webp"
                className="w-[206px] absolute bottom-0 right-[60px]"
                alt=""
              />
              <img
                className="w-[360px] absolute bottom-0 right-[16px] z-[3]"
                src="/teams/team-banner.svg"
                alt=""
              />
              <span className="name-container text-[#FFFFFF] text-[25px] font-bold absolute z-[4] bottom-[14px] left-[52px]">
                نام و نام خانوادگی
              </span>
              <img
                className="w-[214px] absolute bottom-[-38px] right-[36%] z-[2]"
                src="/teams/team-white.svg"
                alt=""
              />
              <span className="name-container text-[#373535] text-[18px] font-bold absolute z-[4] bottom-[-30px] left-[82px]">
                رتبه 3
              </span>
            </motion.div>
          </div>
        );

      default:
        return null;
    }
  };

  return <div className="w-full h-full">{renderOponents(identifier)}</div>;
}
